.root {
  position: relative;
  overflow: hidden;
  border: 1px solid var(--episode-card-border-color);
  border-radius: 2px;

  &::before {
    display: block;
    width: 100%;
    content: "";
  }

  > * {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
}

.photo::before {
  padding-top: 75%; /* 4:3 */
}

.video::before {
  padding-top: 56.25%; /* 16:9 */
}

.verticalVideo::before {
  padding-top: 177.77%; /* 9:16 */
}

.square::before {
  padding-top: 100%; /* 1:1 */
}

.img {
  opacity: 0;
  transition: opacity 100ms;
}

.visible {
  opacity: 1;
}

.play {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: white;
  opacity: 0.85;
  transition: opacity 400ms;

  svg {
    width: 4rem;
    filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.7));
    transition: filter 600ms;
  }

  &:hover {
    svg {
      filter: drop-shadow(0 0 4px rgba(255, 255, 255, 0.5));
      transition: filter 200ms;
    }
    opacity: 1;
    transition: opacity 100ms;
  }
}

.instagram {
  & > * {
    position: absolute;
    top: -55px;
    right: -1px;
    left: -1px;
    /* get rid of the 1px borders */
    width: calc(100% + 2px);
  }

  /* Cancel out instagrams own inlined css */
  iframe {
    min-width: auto !important;
  }

  .fallback {
    top: 0;
    display: none;
    height: 100%;
  }

  /* The blockquote gets removed and switched for a iframe - effectively hiding the fallback */
  blockquote ~ .fallback {
    display: flex;
  }
}

.fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--gray-500);
  background: var(--gray-200);
}
